/**
 * 객체 배열에서 특정 키(key)에 해당하는 값(value)이 일치하는 첫 번째 요소를 반환합니다.
 *
 * @param objArr  검사할 객체 배열
 * @param key     검사할 키 (객체의 프로퍼티 이름)
 * @param value   찾고자 하는 값
 * @returns       일치하는 객체 혹은 없으면 undefined
 */
export function findByKey(objArr, key, value) {
    return objArr.find((item) => item[key] === value);
}
export function setValueByKey(obj, key, value) {
    if (obj) {
        obj[key] = value;
    }
}
/**
 * @description 객체 배열을 탐색·수정할 수 있는 체이너블 유틸리티
 */
export class ObjChain {
    arr;
    current;
    constructor(arr) {
        this.arr = arr;
    }
    /** key가 value인 첫 번째 요소를 찾아 current에 저장 */
    findByKey(key, value) {
        this.current = this.arr.find((item) => item[key] === value);
        return this;
    }
    /** current에 저장된 객체에 key:value를 설정 */
    setValueByKey(key, value) {
        if (this.current) {
            this.current[key] = value;
        }
        return this;
    }
    /** 마지막에 찾아낸 객체를 꺼낼 때 */
    getResult() {
        return this.current;
    }
}
